import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { compose } from "redux";
import { Card } from "@ebsco-ui/ebsco-ui";
import { PUA_UPDATE_PATH } from "../../../constants";
import sharedMessages from "../../../shared-messages";
import {
  getVerificationDataRequestSuccess,
  getVerificationDataSubmitSuccess,
  getResetSuccess
} from "../../store/password/reset";
import WorkflowWizard, { WizardStep } from "../workflow-wizard";
import PageHeader from "../page-header";
import RequestVerificationDataForm from "./request-verification-data-form";
import EnterVerificationDataForm from "./enter-verification-data-form";
import ResetPasswordForm from "./reset-password-form";
import ResetSuccessIndicator from "./reset-success-indicator";

import "./password-reset.scss";

const PasswordReset = ({
  intl: { formatMessage },
  verificationDataRequestSuccess,
  verificationDataSubmitSuccess,
  resetPasswordSuccess,
  returnUrl
}) => {
  const returnLinkUrl = returnUrl ? returnUrl : PUA_UPDATE_PATH;
  const resetPasswordTitle = formatMessage(sharedMessages.resetPassword);

  return (
    <>
      <main className="password-reset">
        <PageHeader
          returnUrl={returnLinkUrl}
          isExternalLink={true}
          returnLinkText={formatMessage(sharedMessages.back)}
          pageTitleText={resetPasswordTitle}
        />
        <Card
          className="password-reset__card"
          border="all"
          isRounded={true}
          isRaised={true}
          isTransparent={false}
        >
          <WorkflowWizard title={resetPasswordTitle}>
            <WizardStep
              isStepComplete={verificationDataRequestSuccess}
              component={RequestVerificationDataForm}
            />
            <WizardStep
              isStepComplete={verificationDataSubmitSuccess}
              component={EnterVerificationDataForm}
            />
            <WizardStep
              isStepComplete={resetPasswordSuccess}
              component={ResetPasswordForm}
            />
            {/**
             * Since the success page is always the last page and wizard
             * should not proceed past it, we explicitly set complete to false
             **/}
            <WizardStep
              isStepComplete={false}
              component={ResetSuccessIndicator}
            />
          </WorkflowWizard>
        </Card>
      </main>
    </>
  );
};

PasswordReset.propTypes = {
  verificationDataRequestSuccess: PropTypes.bool.isRequired,
  returnUrl: PropTypes.string
};

const mapStateToProps = state => ({
  verificationDataRequestSuccess: getVerificationDataRequestSuccess(state),
  verificationDataSubmitSuccess: getVerificationDataSubmitSuccess(state),
  resetPasswordSuccess: getResetSuccess(state),
  returnUrl: state.navigation.returnUrl
});

export { PasswordReset };
export default compose(injectIntl, connect(mapStateToProps))(PasswordReset);
